
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import axios from "axios";

// Components
import LoadingSpinner from './components/loading-spinner.vue';

// Vue Router settings
const router = new VueRouter({
  mode: 'history',
});

// CancelTokens for canceling previous Axios requests.
const CancelToken = axios.CancelToken;
let source;


// Flickity

var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');
var Flickity = require('flickity-bg-lazyload');
var Flickity = require('flickity-imagesloaded');

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

// Hack for IE to prevent scroll jumping bug
// https://github.com/metafizzy/flickity/issues/651#issuecomment-384974621

var focus = Flickity.prototype.focus;
Flickity.prototype.focus = function() {
  // use non-standard setActive for IE11. #651
  if ( this.element.setActive  ) {
    this.element.setActive();
    return;
  }
  // use default
  focus.apply( this, arguments );
};


if (document.getElementById('work-filter') != null) {
  new Vue({
    router,
    delimiters: ['${','}'],
    data() {
      return {
        activeTab: 'featured',
        prerendered: window.__SEARCH__.prerendered || '',
        tabs: window.__SEARCH__.tabs || {},
        tabsLoading: [],
        workApi: '/work.json',
        workEntries: {
          'featured': [],
          'small-business': [],
          'medium-business': [],
          'enterprise-solutions': []
        },
        allIds: [],
        allStyles: []
      }
    },
    methods: {
      setActiveTab: function(size) {
        if (!size) return false;
        this.activeTab = size;
      },
      removeTabsLoading: function(size) {
        for( var i = 0; i < this.tabsLoading.length; i++){
           if ( this.tabsLoading[i] === size) {
             this.tabsLoading.splice(i, 1);
           }
        }
      },
      fetchEntries: function(size) {
        if (!size) return false;

        if (source) {
          source.cancel();
        }
        source = axios.CancelToken.source();

        this.tabsLoading.push(size);

        axios.get(this.searchApi, {
          cancelToken: source.token
        })
        .then(response => {
          this.workEntries[size] = response.data;

          // Add styles to the allStyles array if the entry.id isn't already in the allIds array.
          // But always add styles for large size feature case studies (differnt sized cards
          // could have duplicate ids).
          for (var i = 0; i < this.workEntries[size].length; i++) {
            let id = this.workEntries[size][i].id;

            if (!this.allIds.includes(id) || this.workEntries[size][i].size === 'large') {
              this.allIds.push(id);
              this.allStyles.push(this.workEntries[size][i].styles);
            }
          }
        })
        .catch(error => {
          if (axios.isCancel(error)) {
            // console.log('Request canceled');
          } else {
            console.log(error.message);
          }
        })
        .finally(() => {
          this.removeTabsLoading(size);
        });
      }
    },
    computed: {
      activeTabLabel: function() {
        if (this.activeTab) {
          return this.tabs[this.activeTab];
        } else {
          return this.tabs[0];
        }
      },
      activeTabEntries: function() {
        return this.workEntries[this.activeTab];
      },
      featuredEntry: function() {
        return this.activeTabEntries.filter(function (entry) {
          return entry.size === 'large' ? entry : false;
        })
      },
      gridItems: function() {
        return this.activeTabEntries.filter(function (entry) {
          return entry.size === 'large' ? false : entry;
        })
      },
      searchApi: function() {
        return `${this.workApi}?size=${encodeURIComponent(this.query)}`;
      },
      query: function() {
        return this.activeTab === 'featured' ? '' : this.activeTab;
      },
      showPrerendered: function() {
        return this.activeTab === this.prerendered;
      }
    },
    watch: {
      activeTabEntries: function(newVal, oldVal) {
        if (newVal.length === 0 && (this.activeTab !== this.prerendered)) {
          this.fetchEntries(this.activeTab);
        }
      },
      featuredEntry: function(newVal) {
        // reinit flickity after featured entry changes
        this.$nextTick(function(){
          // Featured card carousel
          $('.js-featured-card-carousel').flickity({
            cellSelector: '.featured-card__slide',
            wrapAround: true,
            prevNextButtons: false,
            setGallerySize: false
          });
        })
      }
    },
    mounted: function() {
    },
    created: function() {
      let sizeQuery = this.$route.query.size;

      if (this.tabs[sizeQuery]) {
        this.activeTab = this.$route.query.size;
      } else {
        this.activeTab = Object.keys(this.tabs)[0];
      }
    },
    components: {
      LoadingSpinner
    }
  }).$mount('#work-filter')
}
